import Navbar from './navbar'
const Header = ()=>{
    return (
        <div>
            <Navbar />
        </div>
    )
}

export default Header;